import classNames from 'classnames'
import * as React from 'react'

import {makeEditable, storyToLink} from '@/common/utils'
import {Grid} from '@/components/Grid'
import Link from '@/components/Link'

const Breadcrumb = ({story, _editable}) => {
  let {breadcrumb = []} = story

  return (
    <section
      {...makeEditable(_editable)}
      className={classNames({
        'bg-yellow-200': story.category.slug === 'livres-blancs',
        'bg-transparent': story.category.slug !== 'livres-blancs',
      })}
    >
      <Grid>
        <ul className='body-s-regular col-span-full flex items-center gap-2 overflow-auto py-6'>
          {breadcrumb.map((story) => (
            <React.Fragment key={story.full_slug}>
              <Link link={storyToLink(story)} className='whitespace-nowrap'>
                <li className='last:text-violet-900  text-violet-400'>
                  {story.title || story.name}
                </li>
              </Link>
              <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='min-w-[16px]'
              >
                <path
                  d='M10.8492 8.35502C10.9456 8.26204 11 8.13389 11 8C11 7.86611 10.9456 7.73796 10.8492 7.64498L5.27342 2.26387C5.17097 2.165 5 2.2376 5 2.37998C5 2.40562 5.00611 2.4309 5.01783 2.45371L7.64092 7.56059C7.78867 7.84825 7.7882 8.1896 7.63964 8.47685L5.01802 13.5461C5.00618 13.569 5 13.5944 5 13.6202C5 13.7625 5.17089 13.8351 5.27329 13.7362L10.8492 8.35502Z'
                  fill='#BEB4FF'
                />
              </svg>
            </React.Fragment>
          ))}
          <li className='whitespace-nowrap'>{story.title || story.name}</li>
        </ul>
      </Grid>
    </section>
  )
}

export default Breadcrumb
